module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('data-table', {
    attrs: {
      "title": _vm.utilLabel + ' Bills',
      "table-ref": "utilbillingtable",
      "url": _vm.url,
      "fields": _vm.siteFields,
      "sort-field": "siteName",
      "search-placeholder": "Site Ids, Site Names, Addresses, Account...",
      "add-props": _vm.addProps,
      "detail-component": "site-util-row"
    },
    on: {
      "toggled": function($event) {
        this.view = !this.view
      }
    },
    scopedSlots: _vm._u([{
      key: "bills-slot",
      fn: function(props) {
        return [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('utility-action', {
          attrs: {
            "button-size": "small",
            "site-data": props.rowData
          }
        })], 1), _vm._v(" "), (_vm.canAccess('finance')) ? _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('utility-payment-action', {
          attrs: {
            "button-size": "small",
            "site-data": props.rowData
          }
        })], 1) : _vm._e()], 1)]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0acb2670"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utility/UtilitiesTable.vue
// module id = 1414
// module chunks = 0